'use client';
import classNames from 'classnames';
import { Button, Title, Flex } from '@gjensidige/builders-components';
import { HeaderFeatureProps as Props } from './types';
import styles from './header-feature.module.less';

const SIZES = `(min-width: 1024px) and (max-width: 1199px) 1024px, (min-width: 1200px) and (max-width: 1619px) 1200px, (min-width: 1620px) 2200px, 100vw`;

export const HeaderFeature = ({
  title,
  image,
  buttons,
  mobileImage
}: Props) => (
  <Flex
    align="end"
    as="header"
    className={classNames(styles.headerFeature, styles.marginBHeaders)}
  >
    {!!image && (
      <img
        alt={mobileImage?.alt || image.alt || ''}
        sizes={SIZES}
        src={mobileImage?.url || image.url}
        srcSet={mobileImage?.srcset || image.srcset}
      />
    )}
    {!!image && (
      <img
        alt={image.alt || ''}
        hidden
        sizes={SIZES}
        src={image.url}
        srcSet={image.srcset}
      />
    )}
    <Flex center layout={{ xs: 1, md: 7.5 }}>
      <Flex layout="1" gap={{ xs: 'xs', md: 'md' }}>
        {!!title && <Title as="h1" text={title} uppercase />}
        {!!buttons?.length && (
          <Flex gap={{ xs: 'xs sm', md: 'md' }}>
            {buttons.map(({ text, url }, index, { length }) => (
              <Button
                key={index}
                href={url}
                data-theme="dark"
                variant={
                  length === 1 ? 'critical' : index ? 'secondary' : 'primary'
                }
              >
                {text}
              </Button>
            ))}
          </Flex>
        )}
      </Flex>
    </Flex>
  </Flex>
);
